// extracted by mini-css-extract-plugin
export default {"DashboardTabs":"index__DashboardTabs__ky7ax"};